import { useEffect, useRef } from 'react';
import PortalModal from '../../../components/PortalModal';
import { track, WEBREG_PREFIX } from '../../../utils/mixpanelHelper';
import {
  userManagementRootEndpoint,
  personifyHealth,
} from '../../../../config';
import { ChatSupportLink } from '../common-components/ChatSupportLink';
import { PH_AUTH_STATES } from '../personify-health/usePersonifyHealth';
import Image from '../../../../media/cookies.svg?react';
import { useI18n } from '../../../i18n/utils';
import { I18N_STR } from '../../../i18n/strings';

export default function PersonifyHealthThirdPartyCookiesModal({ authState }) {
  const modalRef = useRef();
  const { str } = useI18n();

  useEffect(() => {
    if (
      authState === PH_AUTH_STATES.THIRD_PARTY_COOKIE_NOT_SUPPORTED &&
      modalRef?.current
    ) {
      modalRef.current.focus();
    }
  }, [authState]);

  return authState === PH_AUTH_STATES.THIRD_PARTY_COOKIE_NOT_SUPPORTED ? (
    <PortalModal onTop={true}>
      <div className="obstacle-modal ph-modal cookies-modal">
        <div className="inner-modal wrapper" ref={modalRef}>
          <Image />
          <h3>{str(I18N_STR.phCookiesModalTitle)}</h3>
          <p>{str(I18N_STR.phCookiesModalCopy)}</p>
          <div className="form-footer">
            <ChatSupportLink label={str(I18N_STR.contactSupport)} />
            <button
              className="cs-button"
              onClick={() => {
                track(`${WEBREG_PREFIX}:ph-modal-3rd-party-cookies`);
                window.location.replace(
                  `${userManagementRootEndpoint}/v1/login/saml?provider=${personifyHealth.authProvider}`
                );
              }}
            >
              {str(I18N_STR.phCookiesModalButton)}
            </button>
          </div>
        </div>
      </div>
    </PortalModal>
  ) : null;
}
